<template>
  <div class="rounded-sm">
    <a
      :href="href"
      :class="{
        'bg-none': !primary,
        'text-white': !primary,
        'bg-mint-500': primary,
        'text-purple-900': primary,
        'hover:bg-mint-300': primary,
      }"
      class="w-full flex items-center justify-center px-8 py-3 tracking-wider border border-transparent text-sm leading-6 uppercase rounded-full group focus:outline-none focus:shadow-outline transition duration-300 ease-in-out"
    >
      {{ buttonText }}
      <Icon
        v-if="!primary"
        :icon="['fal', 'long-arrow-right']"
        aria-hidden="true"
        class="ml-2 group-hover:ml-4 transition-all duration-300 ease-in-out text-white fill-current"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    href: {
      type: String,
      default: '#',
    },
    buttonText: {
      type: String,
      default: 'Button Text',
    },
    primary: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
